module.exports = __webpack_public_path__ + "img/禹南星.b027b2a9.jpg";